document.documentElement.className = 'js';

// SCREEN
const Sc = {
    // height
    webp:false,
    _h:0,_height:0,
    get height() {return this._h},
    set height(h) {
        this._height = this.height;
        this._h = h;
        this.top_max = document.documentElement.scrollHeight - this.height;
    },
    // width
    _w : 0,_width: 0,
    get width() {return this._w},
    set width(w) {
        this._width = this.width;
        this._w = w;
    },
    // top
    _t:0,_top:0,delta:0,top_max:0,
    get top() {return this._t},
    set top(t) {
        this._top = this.top;
        this._t = t;
        this.delta = this.top - this._top;
    },
    // onload
    _onloads : [],
    get onloads() {return this._onloads;},
    set onloads(fn) {this._onloads.push(fn);},
    onload : () => {
        if (document.head.children[document.head.children.length-1].tagName==='STYLE') document.head.children[document.head.children.length-1].remove();

        window.onresize = () => Sc.update();
        window.onscroll = () => Sc.update('scroll');
        Sc.update();

        Sc.onloads.forEach((fn)=>{fn();});
    },
    // update
    _updates : [],
    get updates() {return this._updates;},
    set updates(fn) {this._updates.push(fn);},
    detachUpdate : (dfn) => {Sc._updates = Sc.updates.filter(fn => fn !== dfn)},
    update : (type='resize') => {
        Sc.top = document.body.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
        if (type==='resize') {
            Sc.width = window.innerWidth || document.documentElement.clientWidth;
            Sc.height = window.innerHeight || document.documentElement.clientHeight;
        }
        Sc.updates.forEach((fn)=>{fn(type);});
    },
}

let webp_img = new Image();
webp_img.onload = function() {Sc.webp=true;document.documentElement.classList.add("webp");};
webp_img.onerror = function() {Sc.webp=false;document.documentElement.classList.add("no-webp");};
webp_img.src = 'assets/img/dots.webp';

window.onload = () => Sc.onload();


export default Sc;